(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cloudless-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cloudless-announcement-slider')) {
    customElements.define('cloudless-announcement-slider', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-announcement-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
        this.mediaQuery = window.matchMedia('(max-width: 640px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.delay = Math.max(Number(this.dataset.autoplaySeconds) || 5, 1) * 1000;
        this.index = 0;
        this.abortController = new AbortController();
        this.scrollTimeout = 0;
        this.fitObserver = new ResizeObserver(() => this.fitText());
        this.fitObserver.observe(this);

        if (!this.viewport || this.slides.length < 2) return;

        const signal = this.abortController.signal;
        this.viewport.addEventListener('scroll', () => this.handleScroll(), { passive: true, signal });
        this.viewport.addEventListener('pointerdown', () => this.stop(), { signal });
        this.viewport.addEventListener('pointerup', () => this.start(), { signal });
        this.viewport.addEventListener('pointercancel', () => this.start(), { signal });
        this.viewport.addEventListener('focusin', () => this.stop(), { signal });
        this.viewport.addEventListener('focusout', () => this.start(), { signal });
        this.mediaQuery.addEventListener('change', () => this.start(), { signal });
        this.reducedMotion.addEventListener('change', () => this.start(), { signal });
        document.addEventListener('visibilitychange', () => this.start(), { signal });
        this.addEventListener('shopify:block:select', (event) => this.selectBlock(event), { signal });
        this.addEventListener('shopify:block:deselect', () => this.start(), { signal });
        this.start();
      }

      disconnectedCallback() {
        this.fitObserver?.disconnect();
        this.stop();
        window.clearTimeout(this.scrollTimeout);
        this.abortController?.abort();
      }

      // Keeps every message on one line: shrinks the font in small steps (to 11px at most) while it overflows.
      fitText() {
        this.querySelectorAll('.cl-announcement__message, [data-announcement-slide]').forEach((element) => {
          element.style.fontSize = '';
          if (!element.clientWidth) return;
          let size = parseFloat(getComputedStyle(element).fontSize);
          while (element.scrollWidth > element.clientWidth + 1 && size > 11) {
            size -= 0.5;
            element.style.fontSize = `${size}px`;
          }
        });
      }

      handleScroll() {
        window.clearTimeout(this.scrollTimeout);
        this.scrollTimeout = window.setTimeout(() => {
          const scrollPosition = Math.abs(this.viewport.scrollLeft);
          const closestSlide = this.slides.reduce((closest, slide, index) => {
            const distance = Math.abs(Math.abs(slide.offsetLeft) - scrollPosition);
            return distance < closest.distance ? { index, distance } : closest;
          }, { index: 0, distance: Infinity });
          this.index = closestSlide.index;
          this.start();
        }, 120);
      }

      selectBlock(event) {
        const selectedIndex = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (selectedIndex < 0) return;
        this.stop();
        this.goTo(selectedIndex, event.detail.load ? 'auto' : 'smooth');
      }

      goTo(index, behavior = 'smooth') {
        this.index = (index + this.slides.length) % this.slides.length;
        this.viewport.scrollTo({ left: this.slides[this.index].offsetLeft, behavior });
      }

      start() {
        this.stop();
        if (!this.mediaQuery.matches || this.reducedMotion.matches || document.hidden) return;
        this.timer = window.setTimeout(() => this.goTo(this.index + 1), this.delay);
      }

      stop() {
        window.clearTimeout(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloudless-articles"] && !Shopify.designMode) return;
  try {
    
  const cloudlessReveal = () => {
    const items = document.querySelectorAll('.cl-reveal:not([data-cl-reveal])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: .15 });
    items.forEach((item) => {
      item.dataset.clReveal = 'true';
      observer.observe(item);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cloudlessReveal);
  } else {
    cloudlessReveal();
  }
  document.addEventListener('shopify:section:load', cloudlessReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloudless-header"] && !Shopify.designMode) return;
  try {
    
  class CloudlessHeader extends HTMLElement {
    connectedCallback() {
      this.handleCartChange = this.handleCartChange.bind(this);
      this.handlePageShow = this.handlePageShow.bind(this);
      document.addEventListener('cart:change', this.handleCartChange);
      window.addEventListener('pageshow', this.handlePageShow);
      this.desktopMenus = [...this.querySelectorAll('[data-mega-details], [data-country-details]')];
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleMobileCloseClick = this.handleMobileCloseClick.bind(this);
      this.handleMobileToggle = this.handleMobileToggle.bind(this);
      this.closeTimers = new Map();
      this.mobileMenu = this.querySelector('[data-mobile-menu]');
      this.mobileMenu?.setAttribute('data-motion-ready', '');
      this.mobileCloseButton = this.querySelector('[data-cloudless-menu-close]');
      this.lastScrollY = window.scrollY;
      this.scrollFrame = null;
      this.handleScroll = this.handleScroll.bind(this);

      this.desktopMenus.forEach((menu) => {
        menu.addEventListener('toggle', () => {
          if (!menu.open) return;
          this.desktopMenus.forEach((otherMenu) => {
            if (otherMenu !== menu) otherMenu.removeAttribute('open');
          });
        });

        if (this.dataset.megaTrigger === 'hover' && menu.matches('[data-mega-details]')) {
          menu.addEventListener('pointerenter', () => {
            window.clearTimeout(this.closeTimers.get(menu));
            menu.setAttribute('open', '');
          });
          menu.addEventListener('pointerleave', () => {
            const timer = window.setTimeout(() => menu.removeAttribute('open'), 140);
            this.closeTimers.set(menu, timer);
          });
        }
      });

      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keydown', this.handleKeydown);
      this.mobileCloseButton?.addEventListener('click', this.handleMobileCloseClick);
      this.mobileMenu?.addEventListener('toggle', this.handleMobileToggle);
      if (this.hasAttribute('data-hide-on-scroll')) window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    // The count is rendered by Liquid; keep it in sync when the cart changes without a page load (drawer, buy box).
    handleCartChange(event) {
      const count = event.detail?.cart?.item_count;
      if (typeof count === 'number') this.setCartCount(count);
      else this.refreshCartCount();
    }

    // Back from checkout: the browser shows the page from its cache (bfcache or HTTP cache) with an old cart
    handlePageShow(event) {
      const navigation = performance.getEntriesByType?.('navigation')?.[0];
      if (event.persisted || navigation?.type === 'back_forward') this.refreshCartCount();
    }

    async refreshCartCount() {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js?_=${Date.now()}`, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error(`cart.js ${response.status}`);
        this.setCartCount((await response.json()).item_count);
      } catch (error) {
        console.warn('Cloudless header: could not refresh the cart count', error);
      }
    }

    setCartCount(count) {
      this.querySelectorAll('[data-cl-cart-link]').forEach((link) => {
        let badge = link.querySelector('.cl-header__count');
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'cl-header__count';
            link.append(badge);
          }
          badge.textContent = count;
        } else {
          badge?.remove();
        }
      });
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this.handleCartChange);
      window.removeEventListener('pageshow', this.handlePageShow);
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleKeydown);
      this.mobileCloseButton?.removeEventListener('click', this.handleMobileCloseClick);
      this.mobileMenu?.removeEventListener('toggle', this.handleMobileToggle);
      window.removeEventListener('scroll', this.handleScroll);
      window.cancelAnimationFrame(this.scrollFrame);
      this.closeTimers?.forEach((timer) => window.clearTimeout(timer));
      window.clearTimeout(this.mobileCloseTimer);
      window.cancelAnimationFrame(this.mobileOpenFrame);
      window.cancelAnimationFrame(this.mobileReadyFrame);
    }

    handleDocumentClick(event) {
      this.desktopMenus.forEach((menu) => {
        if (menu.open && !menu.contains(event.target)) menu.removeAttribute('open');
      });
    }

    handleKeydown(event) {
      if (event.key !== 'Escape') return;
      const openMenu = this.desktopMenus.find((menu) => menu.open);
      const openMobileMenu = this.querySelector('[data-mobile-menu][open]');
      if (openMenu) {
        openMenu.removeAttribute('open');
        openMenu.querySelector('summary')?.focus();
        return;
      }
      if (openMobileMenu) {
        this.closeMobileMenu(true);
      }
    }

    handleMobileCloseClick(event) {
      event.preventDefault();
      this.closeMobileMenu(true);
    }

    handleMobileToggle() {
      this.handleScroll();
      window.cancelAnimationFrame(this.mobileOpenFrame);
      window.cancelAnimationFrame(this.mobileReadyFrame);

      if (!this.mobileMenu?.open) {
        this.mobileMenu?.removeAttribute('data-open-ready');
        this.mobileMenu?.removeAttribute('data-closing');
        return;
      }

      this.mobileMenu.removeAttribute('data-closing');
      this.mobileMenu.removeAttribute('data-open-ready');
      this.mobileOpenFrame = window.requestAnimationFrame(() => {
        this.mobileReadyFrame = window.requestAnimationFrame(() => {
          this.mobileMenu?.setAttribute('data-open-ready', '');
        });
      });
    }

    handleScroll() {
      if (this.scrollFrame !== null) return;
      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null;
        const currentScrollY = window.scrollY;
        const threshold = Math.max(90, window.innerHeight * .2);
        const delta = currentScrollY - this.lastScrollY;
        const menuIsOpen = Boolean(this.mobileMenu?.open || this.desktopMenus.some((menu) => menu.open));
        if (menuIsOpen || currentScrollY < threshold || delta < -4) {
          this.removeAttribute('data-hidden');
        } else if (delta > 4) {
          this.setAttribute('data-hidden', '');
        }
        if (Math.abs(delta) > 4 || currentScrollY < threshold) this.lastScrollY = currentScrollY;
      });
    }

    closeMobileMenu(restoreFocus = false) {
      if (!this.mobileMenu?.open || this.mobileMenu.hasAttribute('data-closing')) return;
      window.cancelAnimationFrame(this.mobileOpenFrame);
      window.cancelAnimationFrame(this.mobileReadyFrame);
      this.mobileMenu.setAttribute('data-closing', '');
      window.clearTimeout(this.mobileCloseTimer);
      this.mobileCloseTimer = window.setTimeout(() => {
        this.mobileMenu.removeAttribute('open');
        this.mobileMenu.removeAttribute('data-closing');
        this.mobileMenu.removeAttribute('data-open-ready');
        if (restoreFocus) this.mobileMenu.querySelector(':scope > summary')?.focus();
      }, 260);
    }

    closeDesktopMenus() {
      this.desktopMenus.forEach((menu) => menu.removeAttribute('open'));
    }
  }

  if (!customElements.get('cloudless-header')) customElements.define('cloudless-header', CloudlessHeader);

  document.addEventListener('shopify:block:select', (event) => {
    const header = event.target.closest('cloudless-header');
    if (!header) return;
    const selectedBlock = header.querySelector(`[data-mega-details][data-block-id="${event.detail.blockId}"]`);
    selectedBlock?.setAttribute('open', '');
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloudless-hero"] && !Shopify.designMode) return;
  try {
    
  class CloudlessMobileHero extends HTMLElement {
    connectedCallback() {
      this.mobileQuery = window.matchMedia('(max-width: 640px)');
      this.update = this.update.bind(this);
      window.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update, { passive: true });
      this.mobileQuery.addEventListener('change', this.update);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
      this.mobileQuery?.removeEventListener('change', this.update);
      document.documentElement.classList.remove('cl-mobile-hero-clear', 'cl-mobile-hero-clear-dark');
    }

    update() {
      const header = document.querySelector('.cl-header');
      const announcement = document.querySelector('.cl-announcement');
      const headerHeight = header?.getBoundingClientRect().height || 56;
      const groupHeight = headerHeight + (announcement?.getBoundingClientRect().height || 0);
      this.style.setProperty('--cl-mobile-hero-header-height', `${headerHeight}px`);
      this.style.setProperty('--cl-mobile-hero-group-height', `${groupHeight}px`);
      const clearHeader = this.dataset.transparentHeader === 'true' && this.mobileQuery.matches && window.scrollY < 24;
      document.documentElement.classList.toggle('cl-mobile-hero-clear', clearHeader);
      document.documentElement.classList.toggle('cl-mobile-hero-clear-dark', clearHeader && this.dataset.darkText === 'true');
    }
  }

  if (!customElements.get('cloudless-mobile-hero')) customElements.define('cloudless-mobile-hero', CloudlessMobileHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloudless-products"] && !Shopify.designMode) return;
  try {
    
  class CloudlessSlider extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-slider-scroller]');
      this.bar = this.querySelector('[data-slider-progress]');
      this.previous = this.querySelector('[data-slider-previous]');
      this.next = this.querySelector('[data-slider-next]');
      if (!this.scroller) return;
      this.update = this.update.bind(this);
      this.scroller.addEventListener('scroll', this.update, { passive: true });
      this.previous?.addEventListener('click', () => this.move(-1));
      this.next?.addEventListener('click', () => this.move(1));
      let pointerDown = false;
      let startX = 0;
      let startScroll = 0;
      let moved = false;
      this.scroller.addEventListener('pointerdown', (event) => {
        pointerDown = true;
        moved = false;
        startX = event.clientX;
        startScroll = this.scroller.scrollLeft;
      });
      this.scroller.addEventListener('pointermove', (event) => {
        if (!pointerDown) return;
        const difference = event.clientX - startX;
        if (Math.abs(difference) > 6) {
          moved = true;
          this.scroller.setPointerCapture?.(event.pointerId);
        }
        if (moved) this.scroller.scrollLeft = startScroll - difference;
      });
      const endPointer = () => {
        pointerDown = false;
      };
      this.scroller.addEventListener('pointerup', endPointer);
      this.scroller.addEventListener('pointercancel', endPointer);
      this.update();
    }

    move(direction) {
      const card = this.scroller.querySelector('.cl-product');
      const distance = card ? card.getBoundingClientRect().width + 12 : this.scroller.clientWidth * .75;
      this.scroller.scrollBy({ left: distance * direction, behavior: 'smooth' });
    }

    update() {
      if (!this.bar) return;
      const maximum = this.scroller.scrollWidth - this.scroller.clientWidth;
      const travel = this.bar.parentElement.clientWidth - this.bar.clientWidth;
      const offset = maximum > 0 ? this.scroller.scrollLeft / maximum * travel : 0;
      this.bar.style.transform = `translateX(${offset}px)`;
    }
  }

  if (!customElements.get('cloudless-slider')) customElements.define('cloudless-slider', CloudlessSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloudless-quote"] && !Shopify.designMode) return;
  try {
    
  class CloudlessQuote extends HTMLElement {
    connectedCallback() {
      this.quote = this.querySelector('blockquote');
      if (!this.quote) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.quote.style.color = 'var(--cl-quote-active)';
        return;
      }
      const words = this.quote.textContent.split(/(\s+)/);
      this.quote.textContent = '';
      this.words = [];
      words.forEach((word) => {
        if (!word.trim()) {
          this.quote.append(document.createTextNode(word));
          return;
        }
        const span = document.createElement('span');
        span.textContent = word;
        this.quote.append(span);
        this.words.push(span);
      });
      this.frame = null;
      this.scheduleUpdate = this.scheduleUpdate.bind(this);
      window.addEventListener('scroll', this.scheduleUpdate, { passive: true });
      window.addEventListener('resize', this.scheduleUpdate, { passive: true });
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      if (!this.scheduleUpdate) return;
      window.removeEventListener('scroll', this.scheduleUpdate);
      window.removeEventListener('resize', this.scheduleUpdate);
      window.cancelAnimationFrame(this.frame);
    }

    scheduleUpdate() {
      if (this.frame !== null) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      const bounds = this.quote.getBoundingClientRect();
      const viewport = window.innerHeight || 1;
      const progress = Math.min(1, Math.max(0, (viewport * .88 - bounds.top) / (viewport * .56)));
      const head = progress * (this.words.length + 2) - 1;
      this.words.forEach((word, index) => {
        const fill = Math.min(1, Math.max(0, head - index + 1));
        word.style.setProperty('--cl-word-progress', `${(fill * 100).toFixed(1)}%`);
      });
    }
  }

  if (!customElements.get('cloudless-quote')) customElements.define('cloudless-quote', CloudlessQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloudless-reviews"] && !Shopify.designMode) return;
  try {
    
  class CloudlessMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-marquee-track]');
      this.group = this.querySelector('[data-marquee-group]');
      if (!this.track || !this.group) return;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerEnd = this.handlePointerEnd.bind(this);
      this.addEventListener('pointerdown', this.handlePointerDown);
      this.addEventListener('pointermove', this.handlePointerMove);
      this.addEventListener('pointerup', this.handlePointerEnd);
      this.addEventListener('pointercancel', this.handlePointerEnd);
      if (this.reducedMotion) return;
      this.originalCards = [...this.group.children].map((card) => card.cloneNode(true));
      if (!this.originalCards.length) return;
      this.originalDistance = this.group.getBoundingClientRect().width;
      this.refresh = this.refresh.bind(this);
      this.resizeObserver = new ResizeObserver(this.refresh);
      this.resizeObserver.observe(this);
      this.refresh();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.momentumFrame);
      this.removeEventListener('pointerdown', this.handlePointerDown);
      this.removeEventListener('pointermove', this.handlePointerMove);
      this.removeEventListener('pointerup', this.handlePointerEnd);
      this.removeEventListener('pointercancel', this.handlePointerEnd);
    }

    handlePointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (this.reducedMotion && event.pointerType !== 'mouse') return;
      cancelAnimationFrame(this.momentumFrame);
      const animations = this.track.getAnimations();
      const animation = animations.find((item) => item.animationName === 'cl-review-marquee') || animations[0];
      if (!this.reducedMotion && !animation) return;
      this.dragPointerId = event.pointerId;
      this.dragStartX = event.clientX;
      this.dragStartScroll = this.scrollLeft;
      this.dragLastX = event.clientX;
      this.dragLastTime = event.timeStamp;
      this.dragVelocity = 0;
      this.dragSensitivity = event.pointerType === 'mouse' ? 1.5 : 2.4;
      this.dragAnimation = animation;
      this.dragStartTime = Number(animation?.currentTime) || 0;
      this.dragDuration = Number(animation?.effect.getTiming().duration) || 0;
      this.setPointerCapture(event.pointerId);
      this.classList.add('is-dragging');
      animation?.pause();
    }

    handlePointerMove(event) {
      if (event.pointerId !== this.dragPointerId) return;
      const distanceX = event.clientX - this.dragStartX;
      const elapsed = Math.max(1, event.timeStamp - this.dragLastTime);
      const velocity = (event.clientX - this.dragLastX) / elapsed;
      this.dragVelocity = this.dragVelocity * .65 + velocity * .35;
      this.dragLastX = event.clientX;
      this.dragLastTime = event.timeStamp;
      if (this.reducedMotion) {
        this.scrollLeft = this.dragStartScroll - distanceX;
        return;
      }
      if (!this.dragAnimation || !this.dragDuration || !this.marqueeDistance) return;
      const direction = this.classList.contains('cl-marquee--reverse') ? 1 : -1;
      const nextTime = this.dragStartTime + distanceX * this.dragSensitivity * (this.dragDuration / this.marqueeDistance) * direction;
      this.dragAnimation.currentTime = ((nextTime % this.dragDuration) + this.dragDuration) % this.dragDuration;
    }

    handlePointerEnd(event) {
      if (event.pointerId !== this.dragPointerId) return;
      if (this.hasPointerCapture(event.pointerId)) this.releasePointerCapture(event.pointerId);
      this.classList.remove('is-dragging');
      const animation = this.dragAnimation;
      const duration = this.dragDuration;
      const idleTime = event.timeStamp - this.dragLastTime;
      const velocity = event.type === 'pointercancel' || idleTime > 80 ? 0 : this.dragVelocity;
      this.dragPointerId = undefined;
      this.dragAnimation = undefined;
      if (!animation || this.reducedMotion || Math.abs(velocity) < .04 || !duration || !this.marqueeDistance) {
        animation?.play();
        return;
      }
      const direction = this.classList.contains('cl-marquee--reverse') ? 1 : -1;
      const momentumDistance = Math.max(-this.clientWidth, Math.min(this.clientWidth, velocity * 280 * this.dragSensitivity));
      const startTime = Number(animation.currentTime) || 0;
      const targetDelta = momentumDistance * (duration / this.marqueeDistance) * direction;
      const momentumDuration = Math.max(180, Math.min(380, Math.abs(momentumDistance) * .9));
      const startedAt = performance.now();
      const applyMomentum = (now) => {
        const progress = Math.min(1, (now - startedAt) / momentumDuration);
        const eased = 1 - Math.pow(1 - progress, 3);
        const nextTime = startTime + targetDelta * eased;
        animation.currentTime = ((nextTime % duration) + duration) % duration;
        if (progress < 1 && this.dragPointerId === undefined) {
          this.momentumFrame = requestAnimationFrame(applyMomentum);
          return;
        }
        animation.play();
      };
      this.momentumFrame = requestAnimationFrame(applyMomentum);
    }

    cleanClone(node) {
      node.setAttribute('aria-hidden', 'true');
      node.removeAttribute('data-shopify-editor-block');
      node.querySelectorAll('[data-shopify-editor-block]').forEach((element) => element.removeAttribute('data-shopify-editor-block'));
      node.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      return node;
    }

    refresh() {
      this.track.querySelectorAll('[data-marquee-clone]').forEach((clone) => clone.remove());
      const minimumWidth = this.clientWidth + 312;
      while (this.group.getBoundingClientRect().width < minimumWidth) {
        this.originalCards.forEach((card) => this.group.append(this.cleanClone(card.cloneNode(true))));
      }
      const distance = this.group.getBoundingClientRect().width;
      const baseDuration = Number.parseFloat(this.dataset.duration) || 70;
      const speed = this.originalDistance / baseDuration;
      const duplicateGroup = this.cleanClone(this.group.cloneNode(true));
      duplicateGroup.dataset.marqueeClone = 'true';
      this.track.append(duplicateGroup);
      this.marqueeDistance = distance;
      this.style.setProperty('--cl-marquee-distance', `${distance}px`);
      this.style.setProperty('--cl-marquee-duration', `${distance / speed}s`);
      this.classList.add('is-ready');
    }
  }

  if (!customElements.get('cloudless-marquee')) customElements.define('cloudless-marquee', CloudlessMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloudless-video-cta"] && !Shopify.designMode) return;
  try {
    
  class CloudlessVideoCta extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.loadVideo = this.loadVideo.bind(this);
      if (!('IntersectionObserver' in window)) {
        this.loadVideo();
        return;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.loadVideo();
        this.observer.disconnect();
      }, { rootMargin: '300px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    loadVideo() {
      if (this.video.dataset.src && !this.video.src) {
        this.video.src = this.video.dataset.src;
        this.video.load();
      }
      const playRequest = this.video.play();
      if (playRequest?.catch) playRequest.catch(() => {});
    }
  }

  if (!customElements.get('cloudless-video-cta')) customElements.define('cloudless-video-cta', CloudlessVideoCta);

  } catch(e) { console.error(e); }
})();
})();
